// extracted by mini-css-extract-plugin
export var fullwidth = "fc-image-module--fullwidth--3a4b8";
export var root = "fc-image-module--root--438c7";